import React from 'react';
import VanImg from '../../assets/images/nisaan-urvaan.png'
import { Link } from 'react-router-dom';
import checkCircle from '../../assets/images/check.png';

import moment from 'moment';


function VanSubscribeBanner({vanSubscriptionDetail}) {
    const {subscriptionDetail} = vanSubscriptionDetail || {};

    let subscriptionDetail_contains =  vanSubscriptionDetail?.subscriptionDetail
    let endDate= moment(subscriptionDetail_contains?.end_date).format('YYYY-MM-DD');
    let startDate= moment(subscriptionDetail_contains?.start_date).format('YYYY-MM-DD');

    const amntOfDays = moment(endDate).diff(moment(startDate), "day")
    const currentDate = moment().format('YYYY-MM-DD');

    function calculateRemainingDays(endDate) {
        const currentTime = new Date();
        const endDateNewDate = new Date(endDate);
        const remainingTime = endDateNewDate - currentTime;
        return remainingTime > 0 ? Math.ceil(remainingTime / (1000 * 60 * 60 * 24)) : 0;
    }



  return (
    <div className='van_subscribe_bannerWrap mb-3 align-items-center d-md-flex flex-wrap w-100'>
        <div className='van_img_wrapper'>
            <img src={VanImg} alt='van pic' className='img-fluid van_img'/>
        </div>
        {subscriptionDetail?.subscription_plan ? 
        <div className='van_ban_content subscribed_detail text-center text-md-start mt-2 mt-lg-0 h5 fw-bold text-capitalize '>
            <img src={checkCircle} alt='check icon' style={{marginTop:'-5px'}}/> &nbsp; 
            {/* {subscriptionDetail_contains?.subscription_plan} Month Plan &nbsp; | &nbsp;  */}
            <span>Want to view active plan?</span>
            {/* <span className='text-danger'> {currentDate>endDate ? `Plan Expired on ${endDate}` : `${calculateRemainingDays(endDate)} Days Left  | Expiring On ${moment(endDate).format('DD-MM-YYYY')}`}</span> */}
        </div>
        :
        <div className='van_ban_content text-center my-3 my-md-0 text-md-start'>
            <h4>Do You Need Pick And Drop Vans?</h4>
            <p>Know more about vans and pricing</p>
        </div>
        }
       
        <div className='van_ban_btnsWrap d-flex flex-wrap justify-content-center justify-content-md-end align-items-center'>
            <Link to={`/student/van-subscription/${subscriptionDetail?.student_id}`} className='btn btn-default'>{currentDate>=endDate ? 'Upgrade Plan' : `View Detail`}</Link>
        </div>
    </div>
  )
}

export default VanSubscribeBanner